// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { productCountStyles } from "@sc/Overrides/Widgets/ProductList/ProductListProductCount";
import { color, mergeWithCss, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

const sharedTextStyles: TypographyPresentationProps = {
    variant: "h5",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};

productCountStyles.wrapper = {
    css: css`
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 12px;
    `,
};

productCountStyles.titleWrapper = {
    css: css`
        display: flex;
        gap: 8px 24px;
        padding-bottom: 16px;
        align-items: baseline;
        flex-wrap: wrap;
        ${xScreen("lte", 767)} {
            flex-direction: column;
        }
    `,
};

productCountStyles.textWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        gap: 4px;
    `,
};

productCountStyles.resultsForText = {
    ...mergeWithCss(sharedTextStyles, {
        css: css`
            &:after {
                content: ":";
            }
        `,
    }),
};

productCountStyles.countText = {
    ...sharedTextStyles,
};

productCountStyles.queryText = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
    `,
};

productCountStyles.categoryContentWrapper = {
    css: css`
        & > div {
            margin-bottom: 16px;
        }
    `,
};
